export var DeviceScreenSize;
(function (DeviceScreenSize) {
    DeviceScreenSize[DeviceScreenSize["Mobile"] = 768] = "Mobile";
    DeviceScreenSize[DeviceScreenSize["Tablette"] = 1023] = "Tablette";
})(DeviceScreenSize || (DeviceScreenSize = {}));
export const footerConstants = {
    sizeMessageDebounceMs: 100,
    detailsOpeningAnimationDurationMs: 800,
    // Duration opacity longer than the opening animation duration to ensure that details are fully visible at the end of the animation
    detailsOpacityAnimationDurationMs: 900,
    detailsAnimationType: 'ease-in-out'
};
